import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import { useProjectState } from "../../../context/stateContext";
import appActions from "../../../redux/getOrganizationAndRestaurant/actions";
import PageHeader from "../../../components/Common/PageHeader/PageHeader";
import TablesEfficiencyActions from "../../../components/User/TablesEfficiencyComponents/TablesEfficiencyActions";
import TablesEfficiencyTable from "../../../components/User/TablesEfficiencyComponents/TablesEfficiencyTable";

const { getRestaurants } = appActions;

const TablesEfficiency = () => {
  const { selectedOrganization } = useProjectState();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getRestaurants());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganization]);

  return (
    <div>
      <PageHeader text="Ефективност на маси" />
      <TablesEfficiencyActions />
      <TablesEfficiencyTable />
    </div>
  );
};

export default TablesEfficiency;
